import { render, staticRenderFns } from "./combos_edit.vue?vue&type=template&id=f9464af0&"
import script from "./combos_edit.vue?vue&type=script&lang=coffee&"
export * from "./combos_edit.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports